export function endOfMonthIsoToday(): string {
  const d = new Date()
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0)
  const yyyy = last.getFullYear()
  const mm = String(last.getMonth() + 1).padStart(2, '0')
  const dd = String(last.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

/**
 * Angular DefaultPaymentComponent edit mode:
 * `moment.unix(selectedPayment.created_at).format('YYYY-MM-DD')`.
 * Accepts unix seconds/millis or parseable date strings.
 */
export function paymentCreatedAtToIsoDate(createdAt?: string | number | null): string {
  if (createdAt === undefined || createdAt === null || createdAt === '') return ''

  const numeric = typeof createdAt === 'number' ? createdAt : Number(String(createdAt).trim())
  if (!Number.isNaN(numeric) && String(createdAt).trim().length <= 13 && Number.isFinite(numeric)) {
    const ms = numeric > 1e12 ? numeric : numeric * 1000
    const d = new Date(ms)
    if (Number.isNaN(d.getTime())) return ''
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  const parsed = new Date(String(createdAt))
  if (Number.isNaN(parsed.getTime())) return ''
  const yyyy = parsed.getFullYear()
  const mm = String(parsed.getMonth() + 1).padStart(2, '0')
  const dd = String(parsed.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}
